import { theme } from "config/theme";

const COOKIE_NAME = "prodigio_auth";

const isProduction = process.env.NODE_ENV === "production";

/**
 * Derives the root domain for cookie sharing from theme.project.appUrl.
 *
 * "app.proenem.com.br"             -> ".proenem.com.br"
 * "app.promilitares.com.br"        -> ".promilitares.com.br"
 * "falcon.prodigioeducacao.com"    -> ".prodigioeducacao.com"
 */
function getCookieDomain(): string {
    const appUrl = theme.project.appUrl;
    const parts = appUrl.split(".");

    if (parts.length >= 4 && parts[parts.length - 1] === "br") {
        return "." + parts.slice(-3).join(".");
    }

    return "." + parts.slice(-2).join(".");
}

interface AuthCookieData {
    token: string;
    refresh_token: string;
    tokenLegacy?: string;
}

export function setAuthCookie(data: AuthCookieData): void {
    const value = encodeURIComponent(JSON.stringify(data));
    const maxAge = 60 * 60 * 24 * 30; // 30 days

    let cookie = `${COOKIE_NAME}=${value}; path=/; max-age=${maxAge}; SameSite=Lax`;

    if (isProduction) {
        const domain = getCookieDomain();
        cookie += `; domain=${domain}; Secure`;
    }

    document.cookie = cookie;
}

export function getAuthCookie(): AuthCookieData | null {
    const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));

    if (!match) return null;

    try {
        return JSON.parse(decodeURIComponent(match[1]));
    } catch {
        return null;
    }
}

export function clearAuthCookie(): void {
    let cookie = `${COOKIE_NAME}=; path=/; max-age=0; SameSite=Lax`;

    if (isProduction) {
        const domain = getCookieDomain();
        cookie += `; domain=${domain}; Secure`;
    }

    document.cookie = cookie;
}
